import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { API_END_POINTS, BASE_URL } from "../ApiEndPoints";
import axios from "axios";

export const fieldOfStudyAPI = createAsyncThunk(
  "fieldOfStudyAPI",
  async (credentials, { rejectWithValue }) => {
    try {
      const response = await axios.get(API_END_POINTS.fieldOfStudy, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${credentials.token}`,
        },
      });
      return response.data;
    } catch (error) {
      if (error.response) {
        return rejectWithValue(
          error.response.data.message || "Invalid credentials"
        );
      } else {
        return rejectWithValue("Something went wrong!");
      }
    }
  }
);

export const getAllInstructorsAPI = createAsyncThunk(
  "getAllInstructorsAPI",
  async (credentials, { rejectWithValue }) => {
    try {
      const response = await axios.get(API_END_POINTS.getAllInstructors, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${credentials.token}`,
        },
      });
      return response.data;
    } catch (error) {
      if (error.response) {
        return rejectWithValue(
          error.response.data.message || "Invalid credentials"
        );
      } else {
        return rejectWithValue("Something went wrong!");
      }
    }
  }
);

export const courseAssignmentAPI = createAsyncThunk(
  "courseAssignmentAPI",
  async (credentials, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        BASE_URL + `course/${credentials.course_id}/assignInstructor`,
        credentials.payload,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${credentials.token}`,
          },
        }
      );
      return response.data;
    } catch (error) {
      if (error.response) {
        return rejectWithValue(
          error.response.data.message || "Invalid credentials"
        );
      } else {
        return rejectWithValue("Something went wrong!");
      }
    }
  }
);

export const globalFuncSlice = createSlice({
  name: "globalFunc",
  initialState: {
    fieldsOfStudy: [],
    fieldsLoading: false,
    fieldsError: null,
    instructors: [],
    instructorsLoading: false,
    instructorsError: null,
    courseAssignment: null,
    courseAssignmentLoading: false,
    courseAssignmentError: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Field of Study API
      .addCase(fieldOfStudyAPI.pending, (state) => {
        state.fieldsLoading = true;
        state.fieldsError = null;
      })
      .addCase(fieldOfStudyAPI.fulfilled, (state, action) => {
        state.fieldsLoading = false;
        state.fieldsOfStudy = action.payload.data || []; 
      })
      .addCase(fieldOfStudyAPI.rejected, (state, action) => {
        state.fieldsLoading = false;
        state.fieldsError = action.payload;
      })
      // Get All Instructors API
      .addCase(getAllInstructorsAPI.pending, (state) => {
        state.instructorsLoading = true;
        state.instructorsError = null;
      })
      .addCase(getAllInstructorsAPI.fulfilled, (state, action) => {
        state.instructorsLoading = false;
        state.instructors = action.payload;
      })
      .addCase(getAllInstructorsAPI.rejected, (state, action) => {
        state.instructorsLoading = false;
        state.instructorsError = action.payload;
      })
      // Course Assignment API
      .addCase(courseAssignmentAPI.pending, (state) => {
        state.courseAssignmentLoading = true;
        state.courseAssignmentError = null;
      })
      .addCase(courseAssignmentAPI.fulfilled, (state, action) => {
        state.courseAssignmentLoading = false;
        state.courseAssignment = action.payload;
      })
      .addCase(courseAssignmentAPI.rejected, (state, action) => {
        state.courseAssignmentLoading = false;
        state.courseAssignmentError = action.payload;
      });
  },
});

export default globalFuncSlice.reducer;
